import React, { useState } from 'react';
import { TextField, Button, Box, Typography, Modal } from '@mui/material';
import axios from 'axios';
import { toast, ToastContainer } from 'react-toastify';

const baseURL = process.env.REACT_APP_BASE_URL;

const LinksForm = ({ render, setRender }) => {
    const [links, setLinks] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [modalOpen, setModalOpen] = useState(false); // State to control modal visibility
    const ToasterToggle = JSON.parse(localStorage.getItem("Toaster"));

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        const linksArray = links.split(',').map(link => link.trim()); // Split string into array by commas and trim whitespace

        try {
            const response = await axios.post(`${baseURL}link/create-links`, { links: linksArray },{
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`
                }
            });
            if (ToasterToggle) {
                toast.success(`${response.data.message}`, {
                    position: "top-center",
                    autoClose: 1000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
            }
            setLinks("");
            setRender(!render);
            setModalOpen(false); 
        } catch (error) {
            console.error('Failed to submit links', error);
            if (ToasterToggle) {
                toast.error(`${error.response.data.message}`, {
                    position: "top-center",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
            }
        }
        setIsSubmitting(false);
    };

    const handleOpenModal = () => setModalOpen(true);
    const handleCloseModal = () => setModalOpen(false);

    return (
        <Box style={{ color: "white", textAlign: "center", marginTop: '2rem' }}>
            <ToastContainer
                position="top-center"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
            />

            <Button
                variant="contained"
                onClick={handleOpenModal}
                sx={{ backgroundColor: '#15178e', color: 'white', '&:hover': { backgroundColor: '#0d0d55', color: 'white' } }}
            >
                Create Link
            </Button>

            <Modal
                open={modalOpen}
                onClose={handleCloseModal}
                aria-labelledby="create-link-modal-title"
                aria-describedby="create-link-modal-description"
            >
                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: 400,
                        bgcolor: 'background.paper',
                        border: '2px solid #000',
                        boxShadow: 24,
                        p: 4,
                        borderRadius: 1,
                        color: 'black',
                    }}
                >
                    <Typography id="create-link-modal-title" variant="h6" component="h2">
                        Create Link
                    </Typography>
                    <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 2 }}>
                        <TextField
                            margin="normal"
                            required
                            fullWidth
                            label="Enter Links (comma-separated)"
                            value={links}
                            onChange={(e) => setLinks(e.target.value)}
                            InputLabelProps={{
                                style: { color: 'black' },
                            }}
                            InputProps={{
                                style: { color: 'black' },
                            }}
                            sx={{
                                "& .MuiOutlinedInput-root": {
                                    "& fieldset": {
                                        borderColor: "black",
                                    },
                                    "&:hover fieldset": {
                                        borderColor: "black",
                                    },
                                    "&.Mui-focused fieldset": {
                                        borderColor: "black",
                                    },
                                },
                            }}
                        />
                        <div style={{ display: "flex", justifyContent: "center" }}>
                            <Button
                                type="submit"
                                variant="contained"
                                sx={{ mt: 3, mb: 2, width: "50%", backgroundColor: '#15178e', color: 'white', '&:hover': { backgroundColor: '#0d0d55', color: 'white' } }}
                                disabled={isSubmitting}
                            >
                                Submit
                            </Button>
                        </div>
                    </Box>
                </Box>
            </Modal>
        </Box>
    );
};

export default LinksForm;

